import { cn } from '@/shared/utils';
import type { ComponentType } from 'react';
import { Link } from 'react-router-dom';
import { tv } from 'tailwind-variants';

const styles = tv({
  slots: {
    container:
      'flex items-center cursor-pointer justify-between rounded-3xl gap-[1.6rem] text-secondary headline4 py-[1.2rem] px-[1.6rem] hover:bg-background hover:text-accent-foreground',
    content: 'flex items-center gap-[1.6rem]',
    icon: 'size-[2.4rem]',
    rightIcon: 'size-[2rem] text-tertiary',
  },
  variants: {
    isActive: {
      true: {
        container: 'bg-background text-accent-foreground',
      },
    },
  },
});

type Props = {
  icon: ComponentType<{ className?: string }>;
  label: string;
  href: string;
  isActive: boolean;
  external?: boolean;
  rightIcon?: ComponentType<{ className?: string }>;
  onClick?: () => void;
};

const SidebarNavigationItem = ({
  icon,
  label,
  href,
  isActive,
  external,
  rightIcon,
  onClick,
}: Props) => {
  const IconComponent = icon;
  const RightIcon = rightIcon;

  const classes = styles({ isActive });

  if (external && onClick && href === '') {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(classes.container(), 'w-full')}>
        <div className={classes.content()}>
          <IconComponent className={classes.icon()} />
          <span>{label}</span>
        </div>

        {RightIcon && <RightIcon className={classes.rightIcon()} />}
      </button>
    );
  }

  if (external) {
    return (
      <a
        href={href}
        target={'_blank'}
        rel={'noopener noreferrer'}
        onClick={onClick}
        className={classes.container()}>
        <div className={classes.content()}>
          <IconComponent className={classes.icon()} />
          <span>{label}</span>
        </div>

        {RightIcon && <RightIcon className={classes.rightIcon()} />}
      </a>
    );
  }

  return (
    <Link to={href} className={classes.container()} onClick={onClick}>
      <div className={classes.content()}>
        <IconComponent className={classes.icon()} />
        <span>{label}</span>
      </div>
      {RightIcon && <RightIcon className={classes.rightIcon()} />}
    </Link>
  );
};

export { SidebarNavigationItem };
